import loggingService from '../services/logging';

const logger = loggingService.getLogger();

type GoogleTagManagerEventVariables = {
  /** Identifies the source element or action being tracked (e.g. a button's `data-psa-id`). */
  psaId?: string;
  /** Any additional event-specific payload forwarded to the GTM data layer. */
  [key: string]: unknown;
};

/**
 * https://support.google.com/tagmanager/answer/7679219?hl=en
 */
export default function triggerGoogleTagManagerCustomEvent(
  eventName: string,
  variables?: GoogleTagManagerEventVariables,
) {
  logger.debug(`[GTM Event] ${eventName}`, variables);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...variables,
  });
}
